import { render } from "./ColisErronesPage.vue?vue&type=template&id=2af5ee8c&ts=true"
import script from "./ColisErronesPage.vue?vue&type=script&lang=ts"
export * from "./ColisErronesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__